import { Model } from '../model';
import { Paginated } from '../paginated';

export class Blocked extends Model {
  number: string;
  origin: string;
  originLabel: string;
  insertTime: string;
}

export class Blocklist extends Paginated {
  data: Array<Blocked>;
}

export class ApiGetBlocklistOptionsFilter {
  dateFrom?: Date;
  dateTo?: Date;
  origin?: string[];
}
